import { createFileRoute } from '@tanstack/react-router';

import { ServiceCalendar } from '../../modules/ServiceCalendar/main';

export const Route = createFileRoute('/calendar/')({
  component: RouteComponent,
  head(ctx) {
    return {
      meta: [{ title: 'Service Calendar' }],
    };
  },
});

function RouteComponent() {
  return <ServiceCalendar />;
}
